import sound_alert_1 from './assets/sounds/alert1.mp3';
import sound_alert_2 from './assets/sounds/alert2.mp3';
import sound_alert_3 from './assets/sounds/alert3.mp3';
import sound_alert_4 from './assets/sounds/alert4.mp3';
import sound_alert_5 from './assets/sounds/alert5.mp3';
import sound_alert_6 from './assets/sounds/alert6.mp3';
import sound_alert_7 from './assets/sounds/alert7.mp3';

export default {
    sound_alert_1: sound_alert_1,
    sound_alert_2: sound_alert_2,
    sound_alert_3: sound_alert_3,
    sound_alert_4: sound_alert_4,
    sound_alert_5: sound_alert_5,
    sound_alert_6: sound_alert_6,
    sound_alert_7: sound_alert_7
};
